import request from '@/utils/request'

// 查询银河打本商家列表
export function listShop(query) {
  return request({
    url: '/played/shop/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本商家详细
export function getShop(shopId) {
  return request({
    url: '/played/shop/' + shopId,
    method: 'get'
  })
}

// 新增银河打本商家
export function addShop(data) {
  return request({
    url: '/played/shop',
    method: 'post',
    data: data
  })
}

// 修改银河打本商家
export function updateShop(data) {
  return request({
    url: '/played/shop',
    method: 'put',
    data: data
  })
}

// 删除银河打本商家
export function delShop(shopId) {
  return request({
    url: '/played/shop/' + shopId,
    method: 'delete'
  })
}
